import { render, staticRenderFns } from "./EditPercentageModal.vue?vue&type=template&id=3623a083"
import script from "./EditPercentageModal.vue?vue&type=script&lang=js"
export * from "./EditPercentageModal.vue?vue&type=script&lang=js"
import style0 from "./EditPercentageModal.vue?vue&type=style&index=0&id=3623a083&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports